import dataStore from '../../../data/data';

const pendingIceCandidates = [];

const SocketAudio = async (msg, rtcPeer) => {
  const data = dataStore.getState();
  const message = msg.message;
  const send = dataStore.getState().mirror.socket.send;
  const vitruvianId = data.mirror.vitruvianId;
  
  const addIceCandidate = async (candidate) => {
    if (!candidate) return;

    if (!rtcPeer.remoteDescription) {
      pendingIceCandidates.push(candidate);
      return;
    }

    try {
      await rtcPeer.addIceCandidate(
        new RTCIceCandidate(candidate)
      );
    } catch(err) {
      console.error(
        'ICE candidate error:',
        err
      );
    }
  };

  const flushPendingCandidates = async () => {
    while (pendingIceCandidates.length) {
      await addIceCandidate(
        pendingIceCandidates.shift()
      );
    }
  };

  try {
    switch(message.type) {
      case 'offer': {
        await rtcPeer.setRemoteDescription(
          new RTCSessionDescription(message.offer)
        );

        const answer = await rtcPeer.createAnswer();
        await rtcPeer.setLocalDescription(answer);

        send({
          type:'answer',
          answer
        });

        await flushPendingCandidates();
        break;
      }
      case 'answer': {
        await rtcPeer.setRemoteDescription(
          new RTCSessionDescription(message.answer)
        );

        await flushPendingCandidates();
        break;
      }
      case 'ice-candidate': {
        await addIceCandidate(message.candidate);
        break;
      }

      default:
        break;
    }

  } catch(err) {
    console.error(
      'Signaling error:',
      err
    );
  }
};

export default SocketAudio;